
import { QuestionCircleTwoTone } from '@ant-design/icons'
import { Popover, TableColumnType } from 'antd'
import moment from 'moment'
import React, { useRef } from 'react'
import { AnyIfEmpty } from 'react-redux'

export const DoctorAchievementColumns = (
  categoryValue?: number,
  data?: any
): TableColumnType<any>[] => {

    const Tips = (title: string) => (
      <>
        {title}
        <Popover
          placement='top'
          content='注：按处方分类查询时，处方总金额不统计抹零或手动修改的优惠金额'
        >
          <QuestionCircleTwoTone style={{ marginLeft: '5px' }} />
        </Popover>
      </>
    )
  
  const colsTop: TableColumnType<any>[] = [
    categoryValue == 1 ? {
      title: "医生姓名",
      key: 'treatmentDoctorName',
      width: '4.5rem',
      align: 'center',
      render: (_, e, i) => {
        let span = 0
        if (
          i === 0 ||
          data && data[i - 1]?.treatmentDoctorId !==
          e.treatmentDoctorId
        ) {
          for (let j = i; j < data?.length; ++j) {
            if (
              data[j].treatmentDoctorId ===
              e.treatmentDoctorId
            ) {
              ++span
            } else {
              break
            }
          }
        }
        return {
          props: {
            colSpan: 1,
            rowSpan: span,
            style: {
              whiteSpace: 'nowrap',
            },
          },
          children: e.treatmentDoctorName || '',
        }
      }
    } : {
      title: "医生姓名",
      key: "treatmentDoctorName",
      align: "center",
      render: (_, e) => {
        return {
          props: {
            style: {
              whiteSpace: "nowrap",
            },
          },
          children: e.treatmentDoctorName,
        }
      },
    },
    {
      title: "处方类型",
      key: "categoryName",
      dataIndex: "categoryName",
      align: "center",
      render: (_, r:any) => {
        return r?.categoryName == '合计' ? '' : r?.categoryName
      },
    },
    {
      title: "处方数",
      dataIndex: "recipeCount",
      align: "center",
    },
    {
      title: "人次",
      key: "personTime",
      dataIndex: "personTime",
      align: "center",
      render: (_, r) => {
        return categoryValue == 1 ? '-' : r.personTime
      },
    },
    {
      title: "人均",
      key: "personTimeAvgAmount",
      dataIndex: "personTimeAvgAmount",
      align: "center",
      render: (_, r) => {
        return categoryValue == 1 ? '-' : r.personTimeAvgAmount?.toFixed(2)
      },
    },
    {
      title: categoryValue  == 1 ? Tips('处方总费用') : "总费用",
      dataIndex: "totalPayAmount",
      align: "center",
      render: (_, r) => r.totalPayAmount?.toFixed(2),
    },
    {
      title: "应收总金额",
      dataIndex: "shoudPayAmount",
      key: "shoudPayAmount",
      align: "center",
      render: (_, r) => r.shoudPayAmount?.toFixed(2),
    },
    {
      title: "自费金额",
      dataIndex: "realPayAmount",
      align: "center",
      render: (_, r) => {
        return categoryValue == 1 ? '-' : r.realPayAmount?.toFixed(2)
      },
    },
    {
      title: "医保报销金额",
      dataIndex: "totalInsurancePayAmount",
      align: "center",
      render: (_, r) => {
        return categoryValue == 1 ? '-' : r.totalInsurancePayAmount?.toFixed(2)
      },
    },
    {
      title: "成本总金额",
      key: "totalCost",
      align: "center",
      render: (_, r) => r.totalCost?.toFixed(2),
    },
    {
      title: "利润",
      key: "profit",
      align: "center",
      render: (_, r) => r.profit?.toFixed(2),
    },
    {
      title: "利润率",
      key: "profitRate",
      align: "center",
      render: (_, r) => r.profitRate,
    },
  ]
  return categoryValue  == 1 ? colsTop?.filter((item) => item.key !== 'shoudPayAmount') : colsTop.filter((item) => item.key !== 'categoryName')
}